import { SubscriptionsTableColumnsIntl } from 'types/i18n';

export const subscriptionsTableColumnsIntl: SubscriptionsTableColumnsIntl = {
  id: 'id',
  clientName: 'Клиент',
  amount: 'Сумма, $',
  period: 'Период, мес',
  createdAt: 'Дата создания',
};
